export const CustomHeader = {
    XRequestId: "X-Request-Id",
    XSupportingTenantId: "X-Supporting-Tenant-Id",
    XSupportingTenantSlug: "X-Supporting-Tenant-Slug",
};
export const retrieveCustomHeader = (header, key) => {
    return header[key] ?? header[key.toLowerCase()];
};
//# sourceMappingURL=custom-header.js.map